export function initAccordions() {
    const accordionWrappers = Array.from(document.querySelectorAll(".accordion-wrapper"));
    if (!accordionWrappers.length)
        return;
    const openAccordion = (accordion) => {
        const content = accordion.querySelector(".accordion__content");
        content.style.transition = 'all 0.3s ease-out';
        content.style.maxHeight = content.scrollHeight + "px";
        accordion.classList.add("accordion__active");
    };
    const closeAccordion = (accordion, withAnimation = true) => {
        const content = accordion.querySelector(".accordion__content");
        withAnimation
            ? content.style.transition = 'all 0.3s ease-out'
            : content.style.transition = 'none';
        content.style.maxHeight = null;
        accordion.classList.remove("accordion__active");
    };
    const swapAccordions = (wrapper, clickedAccordion) => {
        const firstAccordion = wrapper.querySelector(".accordion");
        if (clickedAccordion === firstAccordion)
            return;
        wrapper.insertBefore(clickedAccordion, firstAccordion);
    };
    accordionWrappers.forEach((wrapper) => {
        const accordions = Array.from(wrapper.querySelectorAll(".accordion"));
        if (accordions.length) {
            accordions.forEach((accordion) => {
                const intro = accordion.querySelector(".accordion__intro");
                const content = accordion.querySelector(".accordion__content");
                if (accordion.classList.contains('accordion__active')) {
                    openAccordion(accordion);
                }
                intro.addEventListener('click', (e) => {
                    e.stopPropagation();
                    const isSwap = wrapper.hasAttribute('data-swap');
                    const closeOther = wrapper.hasAttribute('data-close-other');
                    if (isSwap) {
                        swapAccordions(wrapper, accordion);
                    }
                    if (content.style.maxHeight) {
                        closeAccordion(accordion);
                    }
                    else {
                        if (closeOther)
                            accordions.forEach((acc) => closeAccordion(acc, isSwap ? false : true));
                        openAccordion(accordion);
                    }
                });
            });
        }
    });
}
